import { createFileRoute } from '@tanstack/react-router'

import { AdminLeaveRequestsPage } from '@/features/leave/pages/AdminLeaveRequestsPage'

export const Route = createFileRoute('/_authenticated/leave-mgt/leave-requests')({
  component: AdminLeaveRequestsPage,
})
